<template>
    <div class="col-2">
        <a href="/settings/terminal" class="btn">{{ $t('terminals.menuName') }}</a>
    </div>
</template>

<script>
export default {
    name: 'SettingMenu',
}
</script>

